import React from 'react';
import PropTypes from 'prop-types';
import {Dropdown, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown} from "reactstrap";
import {SearchInput} from "../../../components/form/SearchInput";
import Component from "../../../components/Component";

class JobBoardFilter extends Component {

    constructor(props) {
        super(props);

        this.state = {
            search: '',
            suggested: []
        }
    }

    onChange(option) {
        let value;
        if (TB.isArray(this.props.value)) {
            if (this.props.setImportanceLevel && !option.importance) {
                option.importance = 2
            }
            value = [...this.props.value];
            value = TB.xorBy(value, [option], 'value');
            if (!value.length) {
                this.setState({editingSelected: false})
            }
        } else if (TB.isObject(this.props.value)) {
            let value = {...this.props.value}

            value[option.name] = !!value[option.name]
        }

        return this.props.onChange(value)
    }

    onChangeImportance(option, importance) {
        if (TB.isArray(this.props.value)) {
            let existing = TB.findIndex(this.props.value, ['value', option.value]);

            if (existing > -1) {
                let value = TB.set([...this.props.value], `[${existing}].importance`, importance);
                // console.log('BrowseTalentFilter @ onChangeImportance -> value', value);
                return this.props.onChange(value)
            }
            else if (TB.isArray(this.state.suggested)) {
                let existing = TB.findIndex(this.state.suggested, ['value', option.value]);

                if (existing > -1) {
                    let selected = TB.set([...this.state.suggested], `[${existing}].importance`, importance);

                    // console.log('BrowseTalentFilter @ onChangeImportance -> selected', selected);
                    return this.setState({selected})
                }
            }

            if (TB.isArray(this.props.options)) {
                let existing = TB.findIndex(this.props.options, ['value', option.value]);

                if (existing > -1) {
                    let options = TB.set([...this.props.options], `[${existing}].importance`, importance);
                    // console.log('BrowseTalentFilter @ onChangeImportance -> options', options);
                    return this.props.onChangeOptions(options)
                }
            }
        }
    }

    getOptions() {
        if (this.state.suggested?.length) {
            return this.state.suggested;
        }
        return this.props.options;
    }

    render() {

        let selectedValues = TB.keyBy(this.props.value || [], 'value');

        let dropdownOptions = this.state.editingSelected ? this.props.value : this.getOptions() || [];
        let allOptions = dropdownOptions;
        if (TB.findIndex(dropdownOptions,'options') !== -1) {
            allOptions = TB.filter(TB.flatten(TB.map(dropdownOptions, 'options')), ['disabled', false]);
        }
        return (
            <div className="filter-button-dropdown">
                <Dropdown isOpen={this.props.isEditing}
                          toggle={() => !this.props.renderLabel && this.props.onToggleEditing()}>
                    <DropdownToggle tag={this.props.renderLabel ? 'div' : undefined} caret disabled={this.props.isDisabled} className={"filter-button " + (this.props.className || '')}>
                        {this.props.renderLabel || (
                            <span>{this.props.label} (
                                <span className={
                                    TB.mapClass("filter-button-label", {
                                        active: (this.props.value || []).length > 0
                                    })}>
                                    {(this.props.value || []).length || "0"}
                                </span>
                                )
                            </span>
                        )}
                    </DropdownToggle>
                    <DropdownMenu className="filter-dropdown-menu" right={this.props.right} modifiers={{
                        setMaxHeight: {
                            enabled: true,
                            fn: (data) => {
                                return {
                                    ...data,
                                    styles: {
                                        ...data.styles,
                                        overflow: 'auto',
                                        maxHeight: '400px',
                                    },
                                };
                            },
                        },
                    }}>
                        <DropdownItem header>
                            <small className="text-bold flex-row flex-no-wrap flex">
                                <span className="text-bold mr-auto">
                                    {this.props.value.length || 'None'} Selected
                                </span>

                                {this.props.value?.length > 0 && this.state.editingSelected && (
                                    <span className="ml-auto text-dark mr-1 clickable px-2 text-uppercase"
                                          onClick={() => this.setState({editingSelected: false})}>
                                    Back
                                </span>
                                )}
                                {this.props.value?.length > 0 && !this.state.editingSelected && (
                                    <span className="ml-auto text-warning mr-1 clickable px-2 text-uppercase"
                                          onClick={() => {
                                              this.setState({search: '', suggested: [], editingSelected: true})
                                          }}>
                                    Edit
                                </span>
                                )}

                                <span className="ml-2 text-dark clickable px-2 text-uppercase"
                                      onClick={this.props.onToggleEditing}>
                                   Done
                                </span>


                            </small>

                        </DropdownItem>
                        <DropdownItem divider/>
                        {!this.state.editingSelected && !TB.find(dropdownOptions, 'options') && (
                            <DropdownItem header tag="div"
                                          className={"all-filter filter-option-form"}>

                                <div className="toggle-title">
                                    {this.props.subLabel || TB.pluralize(this.props.label)}
                                </div>
                                <div className="toggle-select clickable"  onClick={(e) => {
                                    this.props.onChange(allOptions);
                                }}>
                                    All
                                </div>
                                <div className="toggle-select clickable"  onClick={(e) => {
                                    this.props.onChange([]);
                                }}>
                                    None
                                </div>
                            </DropdownItem>
                        )}
                        {this.props.searchEnabled && !this.state.editingSelected && (


                            <DropdownItem tag={'div'} className="filter-search-input" toggle={false}
                                          key={TB.slugify(this.props.label) + '-search'}>
                                <SearchInput
                                    ref={this.SearchInputRef}
                                    value={this.state.search || ''}
                                    placeholder="Start typing to search.."
                                    onSearch={search => {
                                        if (search === '') {
                                            this.setState({search, suggested: [], editingSelected: false})
                                        } else this.setState({search, editingSelected: false})
                                    }}
                                    searchType={'skills'}
                                    valueLabelDisplay={'name'}
                                    onSuggestionsFetched={async (suggested) => {
                                        suggested = TB.map(suggested, option => ({...option, value: option.id}));

                                        this.promisedState({
                                            suggested,
                                            searchError: false
                                        })
                                    }}
                                    onLoading={async (searchLoading) => {
                                        clearTimeout(this.loadTimeout);
                                        if (searchLoading) {
                                            return this.promisedState({searchLoading, searchError: false});
                                        }
                                        await this.promisedState({searchError: false});

                                        this.loadTimeout = setTimeout(() => {
                                            return this.promisedState({searchLoading})
                                        }, 250)
                                    }}
                                    onError={async (searchError) => {
                                        clearTimeout(this.loadTimeout)
                                        await this.promisedState({
                                            searchError, suggested: [
                                                ...this.props.value
                                            ]
                                        });

                                        this.loadTimeout = setTimeout(() => {
                                            return this.promisedState({searchLoading: false})
                                        }, 250)
                                    }}
                                    disabled={this.props.isDisabled}
                                    name={TB.slugify(this.props.label) + '-search'}
                                    searchRequestEndpoint={'/api/talent-skills/search'}
                                />
                            </DropdownItem>
                        )}


                        {TB.map(this.state.editingSelected ? this.props.value : this.getOptions() || [], (option, index) => {
                            let dropdownElements = [];
                            if (option.options) {
                                dropdownElements = TB.map(
                                    option.options,
                                    (cOption, cIndex) => {
                                        let importance;
                                        let existing = selectedValues[cOption.value];
                                        if (existing) {
                                            importance = existing.importance;
                                        }
                                        return this.renderOption(cOption, `${TB.slugify(option.name + cOption.name)}`, importance)
                                    }
                                )
                                dropdownElements.unshift((
                                    <DropdownItem header key={TB.slugify(option.name) + '-header'} className="all-filter filter-option-form">
                                        <div className="toggle-title">
                                            {option.name}
                                        </div>
                                        <div className="toggle-select clickable"  onClick={(e) => {

                                            let values = [...this.props.value, ...option.options];
                                            values = TB.uniqBy(values, 'value');
                                            this.props.onChange(values);
                                        }}>
                                            All
                                        </div>
                                        <div className="toggle-select clickable"  onClick={(e) => {

                                            let removeItemValues = TB.map(option.options, 'value')
                                            let values = TB.filter([...this.props.value], item => !removeItemValues.includes(item.value));

                                            this.props.onChange(values);
                                        }}>
                                            None
                                        </div>
                                    </DropdownItem>
                                ))
                            } else {
                                let importance = option.importance;
                                let existing = selectedValues[option.value];
                                if (existing) {
                                    importance = existing.importance;
                                }
                                dropdownElements = this.renderOption(option, index, importance)
                            }

                            return dropdownElements;
                        })}
                        <DropdownItem divider/>
                        <DropdownItem header>
                            <small className="text-bold flex-row flex-no-wrap flex">

                        <span className="ml-auto text-dark clickable px-2 text-uppercase"
                              onClick={this.props.onToggleEditing}>
                           Done
                        </span>

                            </small>

                        </DropdownItem>
                    </DropdownMenu>


                </Dropdown>

                <div className="help-text">
                    {this.props.formErrors && (
                        <p className="text-danger mb-0">
                            {this.props.formErrors}
                        </p>
                    )}
                </div>
            </div>
        );
    }

    renderOption(option, index, importance = undefined)
    {
        let checked = TB.isArray(this.props.value) ? TB.map(this.props.value, 'value')
            .includes(option.value) : !!this.props.value[option.name];

        if (importance === undefined) {
            if (this.props.setImportanceLevel) {
                importance = 2;
            }
            else if (this.props.setExperienceLevel) {
                importance = TB.values(laravel.talent_experience_levels)[0];
            }
        }

        // console.log('BrowseTalentFilter @ renderOption', {
        //     option, index, importance, checked,
        // });

        return (
            <DropdownItem tag="div" toggle={false}
                          disabled={option.disabled}
                          key={`option-${TB.slugify(option.name || option.value)}-${index}-${importance}`}
                          className={TB.mapClass("filter-option-form", {checked})}>
                <div className={TB.mapClass("form-checkbox", {
                    "disabled-checkbox":option.disabled
                })}>
                    <input type="checkbox"
                           className="form-check-input"
                           name={TB.isArray(this.props.value) ? `${TB.slugify(this.props.label)}[]` : TB.slugify(option.name || option.value)}
                           id={"filter" + option.name}
                           required={false}
                           disabled={option.disabled}
                           onChange={() => this.onChange(option)}
                           checked={checked}/>

                    <label className="form-check-label" htmlFor={"filter" + option.name}>
                        {option.name}
                    </label>

                </div>

                {this.props.setImportanceLevel && (
                    <div className="filter-importance">
                        <UncontrolledDropdown
                            direction="down" tag={'div'} className={TB.mapClass("importance-btn", {
                                disabled: !this.props.value?.length || !TB.find(this.props.value, ['value', option.value])
                        })}>
                            <DropdownToggle caret tag={'div'}>
                                {laravel.importance_levels[importance]}
                            </DropdownToggle>

                            <DropdownMenu>
                                {TB.map(laravel.importance_levels, (label, level) => (
                                    <DropdownItem key={`${index}-importance-${level}`} onClick={() => {
                                        this.onChangeImportance(option, level)
                                    }}>
                                        {label}
                                    </DropdownItem>
                                ))}
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    </div>
                )}

                {this.props.setExperienceLevel && (
                    <div className="filter-importance">
                        <UncontrolledDropdown direction="down" tag={'div'} className="importance-btn">
                            <DropdownToggle caret tag={'div'}>
                                {laravel.talent_experience_levels[importance].level}
                            </DropdownToggle>
                            <DropdownMenu>
                                {TB.map(laravel.talent_experience_levels, (config, key) => (
                                    <DropdownItem key={`${index}-experience-${key}`} onClick={() => {
                                        this.onChangeImportance(option, key)
                                    }}>
                                        {config.level} ({config.label})
                                    </DropdownItem>
                                ))}
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    </div>
                )}
            </DropdownItem>
        )
    }
}

JobBoardFilter.propTypes = {
    onChange: PropTypes.func,
    formErrors: PropTypes.any,
    onToggleEditing: PropTypes.func,
    options: PropTypes.any,
    isDisabled: PropTypes.any,
    searchEnabled: PropTypes.any,
    value: PropTypes.any,
    setImportanceLevel: PropTypes.any,
    setExperienceLevel: PropTypes.any,
};

export default JobBoardFilter;